// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"1ef3ff95","240":"ecdc7e0a","241":"a2d01fe4","382":"be8cd23d","617":"07f740b2","649":"3e4ddf5d"}[chunkId] + ".chunk.css";
};